var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.doesExist)?[_c('controls',{on:{"filter":_vm.filter,"export":_vm.exp}}),_c('cont',{ref:"content"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }